<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="140px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.report.reportNo')" prop="reportNo">
                    <el-input class="handle-input" v-model.trim="queryCondition.reportNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.report.reportType')" prop="reportType">
                    <ic-select v-model="queryCondition.reportType" clearable table="TT_FEEDBACK_REPORT" field="REPORT_TYPE" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.storeNo')" prop="storeNo">
                    <el-input class="handle-input" v-model.trim="queryCondition.storeNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.storeName')" prop="storeName">
                    <el-input class="handle-input" v-model.trim="queryCondition.storeName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.dcName')" prop="tmDcId">
                      <ic-select :table-fields="[{table:'BASE',field:'DC'},{table:'TT_FEEDBACK',field:'DIRECT_SUPPLIER'}]" filterable clearable v-model="queryCondition.tmDcId" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.supplier')" prop="tmSupplierId">
                      <ic-select table="BASE" field="PLANT" filterable clearable v-model="queryCondition.tmSupplierId" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.materialCode')" prop="materialCode">
                      <el-input class="handle-input" v-model.trim="queryCondition.materialCode" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.materialName')" prop="materialName">
                      <el-input class="handle-input" v-model="queryCondition.materialName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.feedbackChannel')" prop="sourceCode">
                      <ic-select v-model="queryCondition.sourceCode" clearable table="TT_FEEDBACK" field="SOURCE_CODE" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.consumeType')" prop="consumeType">
                      <ic-select v-model="queryCondition.consumeType" clearable table="TT_FEEDBACK" field="CONSUME_TYPE" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('storeFeedback.isDirectSale')" prop="isDirectSale">
                      <ic-select v-model="queryCondition.isDirectSale" :options="{Y:$t('common.yes') , N:$t('common.no')}" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <!-- 原型上是反馈是否处理 bug2325 让改成疑问沟通状态-->
                    <el-form-item :label="$t('storeFeedback.report.doubtCommunicationStatus')" prop="answerStatus">
                      <ic-select v-model="queryCondition.answerStatus" clearable :excludes="['STORE_SAVE']" table="TT_FEEDBACK_REPORT" field="QUESTION_STATUS" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
            <el-button size="mini" type="primary" @click="restQueryForm()">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-table ref="table" :data="tableData" border highlight-current-row max-height='420' class="table">
        <el-table-column show-overflow-tooltip fixed prop="reportNo" :label="$t('storeFeedback.report.reportNo')" min-width="200">
          <template slot-scope="scope">
            <div class="a-link" @click="toDetail(scope.row.ttFeedbackReportId)">{{scope.row.reportNo}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="reportType" :label="$t('storeFeedback.report.reportType')"><template slot-scope="scope">{{scope.row.reportType|ic("TT_FEEDBACK_REPORT","REPORT_TYPE")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="storeNo" :label="$t('storeFeedback.storeNo')"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" prop="storeName" :label="$t('storeFeedback.storeName')"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="80" prop="tmDcId" :label="$t('storeFeedback.dcName')"><template slot-scope="scope">{{scope.row.tmDcId|ic("BASE","DC")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip min-width="80" prop="materialCode" :label="$t('storeFeedback.materialCode')"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="130" prop="materialName" :label="$t('storeFeedback.materialName')"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" prop="tmSupplierId" :label="$t('storeFeedback.supplier')"><template slot-scope="scope">{{scope.row.tmSupplierId|ic("BASE","PLANT")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip min-width="80" prop="sourceCode" :label="$t('storeFeedback.feedbackChannel')"><template slot-scope="scope">{{scope.row.sourceCode|ic("TT_FEEDBACK","SOURCE_CODE")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip min-width="70" prop="consumeType" :label="$t('storeFeedback.consumeType')"><template slot-scope="scope">{{scope.row.consumeType|ic("TT_FEEDBACK","CONSUME_TYPE")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip min-width="70" :formatter="formatterYesNo" prop="isDirectSale" :label="$t('storeFeedback.isDirectSale')"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="90" prop="status" :label="$t('storeFeedback.report.doubtCommunicationStatus')"><template slot-scope="scope">{{scope.row.answerStatus|ic("TT_FEEDBACK_REPORT","QUESTION_STATUS")}}</template></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import questionApi from "@/api/storeFeedback/question";
import dataTableUtils from "@/utils/dataTableUtils";
import { Message } from "element-ui";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";

export default {
  components: { IcSelect },
  extends: commonFunction,
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      tableData: [],
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: {
        reportNo: null,
        reportType: null,
        storeNo: null,
        storeName: null,
        tmDcId: null,
        tmSupplierId: null,
        materialCode: null,
        materialName: null,
        sourceCode: null,
        consumeType: null,
        isDirectSale: null,
        answerStatus: null,
        feedbackNo: null,
        creater: null,
        status: null,
        pageNum: 1,
        pageSize: 15
      },
      applyForm: {
        mateCode: '',
        mateName: '',
        applyCount: 0
      },
      applyDialog: false
    }
  },
  extends: dataTableUtils,
  created() {
    this.queryData(1);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      questionApi.list(this.queryCondition).then(resp => {
        let data = resp.data;
        this.tableData = data.records;
        this.totalCount = data.total;
      })
    },
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        reportNo: null,
        reportType: null,
        storeNo: null,
        storeName: null,
        tmDcId: null,
        tmSupplierId: null,
        materialCode: null,
        materialName: null,
        sourceCode: null,
        consumeType: null,
        isDirectSale: null,
        answerStatus: null,
        feedbackNo: null,
        creater: null,
        status: null,
        pageNum: 1,
        pageSize: 15
      }
      this.queryData()
    },
    exportData() {
      reportApi.exportExcel(this.queryCondition).then((data, resp) => {
        this.tableData = resp.resultData;
        this.tableData = resp.totalCount;
      })
    },
    createNewReport() {
      let rows = this.$refs["table"].selection;
      if (rows.length != 1) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      }
      this.$router.push({
        name: "createfeedbackReport",
        query: {
          feedbackId: rows[0].ttFeedbackId,
          action: 'create'
        }
      })
      // reportApi.newReportInit(rows[0].ttFeedbackId).then(resp => {
      // });
    },
    toDetail(id) {
      if (this.actionCheck.actionCheck('Feedback-reportsDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      this.$router.push({
        path: `/feedbackReportQuestion-detail`,
        query: { feedbackReportId: id }
      });
    },
    formatterYesNo: function (row, column) {
      return row[column.property + ""] == "Y" ? this.$t('common.yes') : this.$t('common.no');
    },
    formatterYesNo2: function (row, column) {
      return row[column.property + ""] == "Y" ? this.$t('storeFeedback.report.yes') : this.$t('storeFeedback.report.no');
    },
  }
}

</script>

<style scoped  lang="scss">
.reportQuestionList {
  .table {
    margin-top: 10px;
  }
  .el-select {
    width: 100%;
  }
}
</style>
